import type { Plugin } from "unified";
import { visit } from "unist-util-visit";

// Custom rehype plugin to handle {indent:level} syntax
export const rehypeIndentation: Plugin = () => {
    return (tree: any) => {
        visit(tree, "text", (node: any) => {
            if (typeof node.value === "string") {
                const lines = node.value.split("\n");
                const processedLines: any[] = [];
                let hasIndentation = false;

                lines.forEach((line: string) => {
                    const indentMatch = line.match(/^\{indent:(\d+)\}(.*)/);
                    if (indentMatch) {
                        hasIndentation = true;
                        const indentLevel = parseInt(indentMatch[1]);
                        const content = indentMatch[2];

                        // Create a span element with custom indentation styling
                        processedLines.push({
                            type: "element",
                            tagName: "div",
                            properties: {
                                style: `display: block; margin-left: ${indentLevel * 20}px;`,
                                className: `indent-level-${indentLevel}`,
                            },
                            children: [{ type: "text", value: content }],
                        });
                    } else {
                        processedLines.push({ type: "text", value: line });
                    }
                });

                // Replace the text node with processed content if we found indentation
                if (hasIndentation) {
                    node.type = "element";
                    node.tagName = "div";
                    node.children = processedLines;
                    node.properties = {};
                }
            }
        });
    };
};
